export default "__VITE_ASSET__CUR6_ZbM__";